import { defineNuxtPlugin } from 'nuxt/app'

import { CLIENTPORTAL_EXPERIENCE_RUNTIME_KEY } from '@clientportal/customization-layer/experience/clientportal-experience-context'
import {
  EXPERIENCE_QUERY_PARTITION_SCOPE_KEY,
  type ExperienceQueryPartitionScope,
} from '@common/experience-runtime/composables/useExperienceQueryPartition'
import type { AppId } from '@common/app-access-layer/types/app-access'

import { CLIENTPORTAL_V2_RUNTIME } from '../experience/v2/clientportal-v2-runtime-registry'
import { CLIENTPORTAL_WEB_DEFAULTS_V2 } from '../experience/v2/defaults/clientportal-web-defaults'
import { CLIENTPORTAL_WEB_KIT_V2 } from '../experience/v2/clientportal-web-kit'

/** Single hardcoded ClientPortal V2 document. No published overlay or Customizer preview. */
export const CLIENTPORTAL_EXPERIENCE_RUNTIME_V2 = Object.freeze({
  ...CLIENTPORTAL_V2_RUNTIME,
  kit: CLIENTPORTAL_WEB_KIT_V2,
  defaults: CLIENTPORTAL_WEB_DEFAULTS_V2,
})

const CLIENTPORTAL_QUERY_PARTITION_SCOPE: ExperienceQueryPartitionScope = Object.freeze({
  authorizationApps: Object.freeze<AppId[]>(['communities', 'contracts', 'courses', 'documents', 'estimates', 'events', 'invoices']),
})

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.provide(CLIENTPORTAL_EXPERIENCE_RUNTIME_KEY, CLIENTPORTAL_EXPERIENCE_RUNTIME_V2)
  nuxtApp.vueApp.provide(EXPERIENCE_QUERY_PARTITION_SCOPE_KEY, CLIENTPORTAL_QUERY_PARTITION_SCOPE)
})
